module.exports = __webpack_public_path__ + "img/reload.890b545e.svg";